import axios from "axios";
import Constants from "@helper/Constants";

const THREE_DAYS_IN_MS = 3 * 24 * 60 * 60 * 1000;

/**
 * Valid cached country code from localStorage (same TTL as surrogate lite registration).
 * @returns {string|null}
 */
export function getStoredCountryCode() {
    const stored = localStorage.getItem("countryCode");
    const storedTime = localStorage.getItem("countryCodeTime");
    if (stored && storedTime && Date.now() - Number(storedTime) < THREE_DAYS_IN_MS) {
        return stored;
    }
    return null;
}

export async function fetchAndStoreRegistrationCountryCode() {
    try {
        const ipResponse = await axios.get("https://ipinfo.io/ip");
        const userIp = ipResponse.data;
        const locationResponse = await axios.get(`${Constants.REST_API_URL}api/validation/location?ip=${userIp}`);
        const countryCode = locationResponse.data.country_code;
        localStorage.setItem("countryCode", countryCode);
        localStorage.setItem("countryCodeTime", Date.now());
        return countryCode;
    } catch (error) {
        console.error("An error occurred while fetching the location: ", error);
        return null;
    }
}

/**
 * Returns cached country code or fetches via ipinfo + api/validation/location (surrogate / milk donor registration parity).
 * @returns {Promise<string|null>}
 */
export async function resolveRegistrationCountryCode() {
    const cached = getStoredCountryCode();
    if (cached) {
        return cached;
    }
    return fetchAndStoreRegistrationCountryCode();
}
